let pricemap = new Map();

export default {
    
    setRates(prices) {
        pricemap.clear();

        prices.forEach(item => {
            pricemap.set(item.engine_id, item.rate);
        });

        let ev = new CustomEvent("cds-rates-updated", {
            detail: {
                rates: pricemap
            }
        });

        window.dispatchEvent(ev);
    },

    getPrices() {
        return pricemap;
    }
}